<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-else class="row">
            <div class="col-lg-12 mb-4">
                <div class="box">
                    <div class="box-offset">
                        <div class="todo-edit-top-block">
                            <div class="left-col">
                                <div class="d-flex">Sites/Clients: {{currentTodo.client.name ?? ''}}</div>
                                <div class="d-flex">Created by: {{ currentTodo.creator.name }}
                                    {{ currentTodo.creator.last_name }}
                                </div>
                                <div class="d-flex"> Assigned to: {{ currentTodo.assigned_person.name }}
                                    {{ currentTodo.assigned_person.last_name }}
                                </div>
                                <div class="d-flex">Forwarded from: {{ currentTodo.forward_from?.name ?? '' }}
                                    {{ currentTodo.forward_from?.last_name ?? '' }}
                                </div>
                                <div
                                    v-if="showField('start_date')"
                                    class="d-flex mt-3" >
                                    <b>Start Date:</b>
                                    <input type="date"
                                           v-model="currentTodo.start_date"
                                           @input="updateField('start_date', $event.target.value)"
                                    >
                                    <a href="javascript:void(0)"
                                       class="img-btn edit-link ml-2"
                                       @click="saveNewField('start_date')"
                                    >
                                        <img src="/img/svg/check-5.svg" alt="save">
                                    </a>
                                </div>

                                <div
                                    v-else
                                    class="d-flex mt-3" >
                                    <b>Start Date: {{ currentTodo.start_date ? calculateDate(currentTodo.start_date) : '' }}</b>
                                    <a href="javascript:void(0)"
                                        class="edit-link ml-2"
                                       @focus="focusField('start_date')"
                                       v-if="userInfo.id === currentTodo.creator_id && currentTodo.status !== 'complete'"
                                    ><img src="/img/svg/icons-pen.svg" alt="Edit">
                                    </a>
                                </div>

                                <div
                                    v-if="showField('dead_line')"
                                    class="d-flex mt-3 mb-3" >
                                    <b>Due Date:</b>
                                    <input type="date"
                                           class="ml-1"
                                           v-model="currentTodo.dead_line"
                                           @input="updateField('dead_line', $event.target.value)"
                                    >
                                    <a href="javascript:void(0)"
                                       class="img-btn edit-link ml-2"
                                       @click="saveNewField('dead_line')"
                                    >
                                        <img src="/img/svg/check-5.svg" alt="save">
                                    </a>
                                </div>
                                <div v-else
                                     class="d-flex mt-3 mb-3" >
                                    <b>Due Date: {{currentTodo.dead_line ? calculateDate(currentTodo.dead_line) : '' }}</b>
                                    <a href="javascript:void(0)"
                                       class="edit-link ml-2"
                                       @focus="focusField('dead_line')"
                                       v-if="userInfo.id === currentTodo.creator_id && currentTodo.status !== 'complete'"
                                    ><img src="/img/svg/icons-pen.svg" alt="Edit">
                                    </a>
                                </div>
                            </div>
                            <div class="central-block">
                                <h3>Title: {{ currentTodo.title }}</h3>

                                <div class="d-flex" v-if="showField('description')">
                                    <input
                                        type="text"
                                        class="form-control height-2"
                                        v-model="currentTodo.description"
                                        @input="updateField('description', $event.target.value)">
                                    <a href="javascript:void(0)"
                                       class="img-btn edit-link ml-2"
                                       @click="saveNewField('description')"
                                    ><img src="/img/svg/check-5.svg" alt="save">
                                    </a>
                                </div>
                                <div class="d-flex" v-else>
                                    <p>Description: {{ currentTodo.description }}</p>
                                    <a href="javascript:void(0)"
                                       class="img-btn edit-link ml-2"
                                       @focus="focusField('description')"
                                       v-if="userInfo.id === currentTodo.creator_id && currentTodo.status !== 'complete'"
                                    ><img src="/img/svg/icons-pen.svg" alt="edit">
                                    </a>
                                </div>
                            </div>
                            <div class="col-last">
                                <div :class="getPriorityClass(currentTodo.priority)">Priority: {{currentTodo.priority }}
                                </div>
                                <div class="form-group-btn" v-if="currentTodo.isLocked">
                                    <div class="btn btn--outline-primary d-flex align-items-center justify-content-center btn--small">
                                        Locked
                                        <img src="/img/svg/icons-lock.svg" alt="" class="lock ml-1">
                                    </div>
                                </div>
                                <div class="form-group-btn" v-else>
                                    <select class="custom-select" v-model="currentTodo.status" @change="saveNewField('status')" >
                                        <option value="pending">Pending</option>
                                        <option value="complete">Completed</option>
                                    </select>
                                </div>
                                <div class="item">
                                    <button class="btn btn--outline-primary btn--small pr-6 pl-6 mb-3 mt-2"
                                            @click="showModal"
                                    >Forward<img class="pl-3" src="/img/svg/icons-arrpow.svg" alt="forward">
                                    </button>

                                    <AddNewItemModal
                                        title="Select Employee"
                                        confirm-text="Send"
                                        id="todo-modal"
                                        reject-text="Cancel"
                                        type="select"
                                        :positions="listOfUsers"
                                        @confirm="forwardTodo"
                                    ></AddNewItemModal>

                                </div>
                            </div>
                        </div>
                        <div class="todo-comments-block">
                            <div class="ttl"> Comments</div>
                            <div
                                class="comment-item"
                                v-for="comment in currentTodo.comments"
                                :key="comment.id"
                            >
                                <div
                                    class="avatar"
                                    :style="{'background-image': comment.author.avatar ? getNameOfAvatar(comment.author.avatar) : 'url(/img/svg/emptyAvatar.png)'}"
                                ></div>
                                <div class="item-inner">
                                    <div class="date-time">{{formatDate(comment.created_at)}}</div>
                                    <div class="item-inner-content">
                                        <div class="item-inner-content-text">
                                            <div class="item-ttl">
                                                <h5>{{comment.author.name ?? ''}} {{comment.author.last_name ?? ''}}</h5>
                                            </div>
                                            <input
                                                type="text"
                                                class="form-control mb-0 w-100"
                                                v-model="comment.comment"
                                                v-if="activeComment.id === comment.id"
                                            >
                                            <p v-else>
                                                <pre style="white-space: pre-wrap; font-family: 'Open Sans', sans-serif; font-size: 14px;">{{ comment.comment }}</pre>
                                            </p>
                                        </div>
                                        <div class="action-block" v-if="comment.isEditable ">

                                            <a class="img-btn edit-link ml-2"
                                               v-if="activeComment.id === comment.id"
                                               href="javascript:void(0)">
                                                <img src="/img/svg/check-5.svg" alt="" @click="saveComment(comment)"></a>

                                            <a v-else
                                               href="javascript:void(0)"
                                               class="img-btn edit-link ml-2"
                                               @click="editComment(comment)">
                                                <img src="/img/svg/icons-pen.svg" alt=""></a>
                                            <a
                                                v-show="activeComment.id !== comment.id"
                                                v-if="deletingCommentInTodo"
                                                href="javascript:void(0)"
                                                class="delete-link"
                                                @click="showDeleteModal(comment.id)"
                                            ><img src="/img/svg/on.svg" alt="delete"></a>

                                            <ActionModal confirm-text="Yes"
                                                         reject-text="No"
                                                         :modalId="getDeleteModalId(comment.id)"
                                                         @confirm="deleteComment(comment.id)">
                                                <template #body>
                                                    <div class="text-center mb-4">
                                                        <h4>
                                                            Are you sure you want <br> to delete this item?
                                                        </h4>
                                                    </div>
                                                </template>
                                            </ActionModal>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="new-comment pt-4" v-if="commentBlock">
                                <div class="form-group form-group-1">
                                    <textarea
                                        class="form-control height-2"
                                        placeholder="Add Comment"
                                        v-model="newComment"
                                    ></textarea>
                                </div>
                                <p class="small-text">Please Note: When forwarding the task, all of the comments will
                                    remain in the task from previous contributors. The task will be removed from your
                                    inbox, and moved to the sent folder.
                                </p>
                            </div>
                        </div>
                        <div class="btns-wrap" v-if="commentBlock">
                            <a class="btn btn--outline-primary w-100 w-sm-auto" @click="backToPreviousPage">Cancel</a>
                            <a class="btn btn--outline-primary w-100 w-sm-auto" @click="addNewComment">Add</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import CommonService from "../../../AppUser/resources/js/services/CommonService";
import ToDoService from "./services/ToDoService";
import AddNewItemModal from "../../../../../resources/js/components/AddNewItemModal.vue";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import StyleHandler from "../../../../../resources/js/mixins/StyleHandler";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import listOfUsers from "../../../Users/resources/js/ListOfUsers.vue";

export default {
    name: 'EditToDo',
    components: {ActionModal, AddNewItemModal},
    mixins: [DateConverter, StyleHandler, ModalHandler],
    props: {
       deletingCommentInTodo: {
           type: Boolean,
           required: true
       }
    },
    data() {
        return {
            activeComment: {},
            currentTodo: {},
            priorityColor: null,
            loading: true,
            listOfUsers: [],
            todoId: null,
            userInfo: {},
            editField: '',
            newComment: null,
            commentBlock: false,
        }
    },
    methods: {
        async loadData() {
            this.loading = true;
            try {
                await Promise.all([
                    this.getListOfActiveUsers(),
                    this.getCurrentUser(),
                    this.getTodoId()
                ]);
            } catch (e) {
                console.error("Error loading data");
            } finally {
                this.loading = false;
            }
        },
        async addNewComment() {
            this.$showLoadingMessage()
            if (!this.newComment || this.newComment.trim() === '') {
                this.$showErrorMessage("Your comment is empty");
            } else {
                try {
                    await ToDoService.addNewComment(this.currentTodo.id, this.newComment)
                    this.newComment = ''
                    await this.getTodoData()
                    this.$showSuccessMessage('New comment was added')
                } catch (e) {
                    this.$showErrorMessage('The comment was not added. Please reload page and try again');
                }
            }
        },
        async deleteComment(id) {
            this.$showLoadingMessage();
            this.currentTodo.comments = this.currentTodo.comments.filter((comment) => comment.id !== id)
            try {
                this.$showSuccessMessageDelete();
                await ToDoService.deleteComment(id)
            } catch (error) {
                this.$showErrorMessage('The comment was not deleted. Please try again.');
            }
        },
        editComment(comment) {
            this.activeComment = comment
        },
        focusField(name) {
            this.editField = name;
        },
        async forwardTodo(id) {
            this.$showLoadingMessage()
            if (id) {
                try {
                    const {data: result} = await ToDoService.forwardTodoTo(this.todoId, id);
                    this.currentTodo = result
                    await this.getTodoData()
                    $('#todo-modal').modal('hide');
                    this.$showSuccessMessage('ToDo has been forwarded!');
                } catch (error) {
                    console.error(error);
                }
            } else {
                this.$showErrorMessage('The to-do was not forwarded. Please select assigned person');
            }
        },
        async getCurrentUser() {
            const {data: user} = await CommonService.getUserInfo()
            this.userInfo = user
        },
        async getListOfActiveUsers() {
            try {
                const {data: response} = await CommonService.getListOfActiveUsers()
                this.listOfUsers = response
            } catch (e) {
                console.error(e)
            }
        },
        async getTodoData() {
            try {
                const {data: todo} = await ToDoService.getTodoInfo(this.todoId)
                this.currentTodo = todo
            } catch (e) {

            }
        },
        async getTodoId() {
            const url = window.location.href;
            const match = url.match(/\/(\d+)\/edit$/);

            if (match && match[1]) {
                this.todoId = match[1];
                await this.getTodoData(this.todoId)
            } else {
                this.$showErrorMessage('User ID not found in the URL or invalid URL structure')
            }
        },
        async saveComment(comment) {
            this.$showLoadingMessage()
            if (!comment.comment || comment.comment.trim() === '') {
                this.$showErrorMessage("Your comment is empty");
            } else {
                try {
                    const {data: updatedComment} = await ToDoService.updateComment(comment.id, comment.comment);
                    this.activeComment = updatedComment
                    await this.getTodoData()
                    this.$showSuccessMessage('Your Comment was updated!')
                } catch (e) {
                    this.$showErrorMessage("Your comment was not updated");
                }
            }
        },
        showModal() {
            $(`#todo-modal`).modal()
        },
        showField(name) {
            return this.currentTodo[name] === '' || this.editField === name;
        },
        async saveNewField(field) {
            this.$showLoadingMessage()
            this.editField = '';
            const editableFields = {
                [field]: this.currentTodo[field]
            };
            try {
                await ToDoService.updateTodo(this.todoId, editableFields);
                this.$showSuccessMessage('Todo updated!');
                await this.getTodoData();
                this.editField = '';
            } catch (error) {
                this.$showErrorMessage('Error updating todo')
            }
        },
        showCommentBlock() {
            if (!this.currentTodo.isLocked && this.userInfo.id === this.currentTodo.creator_id) {
                this.commentBlock = true
            }
        },
        updateField(name, value) {
            this.currentTodo[name] = value;
        },
    },
    mounted() {
        this.loadData()
        this.showCommentBlock();
    }
}

</script>

<style scoped>

</style>
